export enum LaunchPadFeatureSelfHosted {
  ConfigureSSO = "ConfigureSSO",
  SetupSlackIntegration = "SetupSlackIntegration",
  CreateWorkerPool = "CreateWorkerPool",
  SetupVCSIntegration = "SetupVCSIntegration",
  InviteTeammates = "InviteTeammates",
}
